export const auth: Record<string, string> = {
  // Login page
  'OdinsEye workspace': 'Espace OdinsEye',
  'Security operations without the spreadsheet feel.':
    'Des opérations de sécurité sans l’esprit tableur.',
  'Give schedulers, supervisors and response teams a single place to manage coverage, alarms and field activity.':
    'Offrez aux planificateurs, superviseurs et équipes d’intervention un seul endroit pour gérer la couverture, les alarmes et l’activité terrain.',
  'Coverage': 'Couverture',
  'Live staffing visibility across sites and shifts':
    'Visibilité en direct des effectifs par site et par vacation',
  'Incident queues and panic alarms in one workflow':
    'Files d’incidents et alarmes de détresse dans un même flux de travail',
  'Operations': 'Opérations',
  'Team, site and patrol coordination without context switching':
    'Coordination des équipes, des sites et des rondes sans changer d’outil',
  'Welcome back': 'Bon retour parmi nous',
  'Sign in to manage operations or access an invited client portal.':
    'Connectez-vous pour gérer les opérations ou accéder à un portail client sur invitation.',
  'Email': 'Adresse e-mail',
  'name@company.com': 'nom@entreprise.com',
  'Password': 'Mot de passe',
  'Enter your password': 'Saisissez votre mot de passe',
  'Please enter email and password': 'Veuillez saisir votre adresse e-mail et votre mot de passe',
  'Login failed': 'Échec de la connexion',
  'Signing in...': 'Connexion...',
  'Sign in': 'Se connecter',
  'Reset password': 'Réinitialiser le mot de passe',
  'Enter your email and we will send you a secure reset link.':
    'Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation sécurisé.',
  'Please enter your email address': 'Veuillez saisir votre adresse e-mail',
  'If an account exists for that email, a reset link has been sent.':
    'Si un compte existe pour cette adresse e-mail, un lien de réinitialisation a été envoyé.',
  'Failed to send password reset email':
    'Impossible d’envoyer l’e-mail de réinitialisation du mot de passe',
  'Forgot password?': 'Mot de passe oublié ?',
  'Sending reset link...': 'Envoi du lien de réinitialisation...',
  'Send reset link': 'Envoyer le lien de réinitialisation',
  'Back to sign in': 'Retour à la connexion',
  'Choose a new password for your operations workspace.':
    'Choisissez un nouveau mot de passe pour votre espace opérationnel.',
  'Your password has been updated. You can continue to the portal.':
    'Votre mot de passe a été mis à jour. Vous pouvez continuer vers le portail.',
  'Failed to update password': 'Impossible de mettre à jour le mot de passe',
  'New password': 'Nouveau mot de passe',
  'Enter your new password': 'Saisissez votre nouveau mot de passe',
  'Confirm your new password': 'Confirmez votre nouveau mot de passe',
  'Updating password...': 'Mise à jour du mot de passe...',
  'Update password': 'Mettre à jour le mot de passe',
  'Continue to portal': 'Continuer vers le portail',

  // Accept invite page
  'Activate Client Portal': 'Activer le portail client',
  'Accept Invite': 'Accepter l’invitation',
  'No invite token provided': 'Aucun jeton d’invitation fourni',
  'Invalid or expired invite': 'Invitation invalide ou expirée',
  'Failed to load invite': 'Impossible de charger l’invitation',
  'Please confirm the client contact name': 'Veuillez confirmer le nom du contact client',
  'Password must be at least 8 characters': 'Le mot de passe doit contenir au moins 8 caractères',
  'Password must contain at least one uppercase letter':
    'Le mot de passe doit contenir au moins une lettre majuscule',
  'Password must contain at least one lowercase letter':
    'Le mot de passe doit contenir au moins une lettre minuscule',
  'Password must contain at least one number':
    'Le mot de passe doit contenir au moins un chiffre',
  'Passwords do not match': 'Les mots de passe ne correspondent pas',
  'Failed to activate invite': 'Impossible d’activer l’invitation',
  'Account creation did not return a user. Check Supabase email confirmation settings.':
    'La création du compte n’a pas renvoyé d’utilisateur. Vérifiez les paramètres de confirmation d’e-mail de Supabase.',
  'Failed to accept invite': 'Impossible d’accepter l’invitation',
  'Client Portal Ready': 'Portail client prêt',
  'Account Created': 'Compte créé',
  'Your client portal credentials have been created. Continue to sign in and view your sites and schedules.':
    'Vos identifiants du portail client ont été créés. Connectez-vous pour consulter vos sites et vos plannings.',
  'Your account has been created successfully. You can now sign in.':
    'Votre compte a été créé avec succès. Vous pouvez maintenant vous connecter.',
  'Go to Portal': 'Accéder au portail',
  'Go to Login': 'Aller à la connexion',
  'You were invited by {company} to access {contract}.':
    '{company} vous a invité à accéder à {contract}.',
  'your client portal': 'votre portail client',
  'Welcome, {name}.': 'Bienvenue, {name}.',
  'Confirm your details and create a password to activate the portal.':
    'Confirmez vos informations et créez un mot de passe pour activer le portail.',
  'Create a password to set up your account.':
    'Créez un mot de passe pour configurer votre compte.',
  'Client contact name': 'Nom du contact client',
  'Confirm Password': 'Confirmer le mot de passe',
  'Activating Portal...': 'Activation du portail...',
  'Creating Account...': 'Création du compte...',
  'Activate Portal': 'Activer le portail',
  'Create Account': 'Créer le compte',

  // Deactivated accounts
  'Account deactivated': 'Compte désactivé',
  'Your account has been deactivated, please contact your company administrator.':
    'Votre compte a été désactivé, veuillez contacter l’administrateur de votre entreprise.',

  // Staff invite page
  'Finish setting up your account': 'Finalisez la configuration de votre compte',
  '{company} has added you to their team as a guard. Confirm your details and choose a password.':
    '{company} vous a ajouté à son équipe en tant qu’agent. Confirmez vos informations et choisissez un mot de passe.',
  '{company} has added you to their operations workspace. Confirm your details and choose a password.':
    '{company} vous a ajouté à son espace opérationnel. Confirmez vos informations et choisissez un mot de passe.',
  'Phone number': 'Numéro de téléphone',
  'A phone number is required': 'Un numéro de téléphone est obligatoire',
  'Enter a valid phone number': 'Saisissez un numéro de téléphone valide',
  'At least 8 characters, with an uppercase letter, a lowercase letter and a number.':
    'Au moins 8 caractères, dont une majuscule, une minuscule et un chiffre.',
  'Finish and open workspace': 'Terminer et ouvrir l’espace de travail',
  'Go to sign in': 'Aller à la connexion',
  'This invite has already been used': 'Cette invitation a déjà été utilisée',
  'Your account is set up. Sign in with your email and the password you chose.':
    'Votre compte est configuré. Connectez-vous avec votre adresse e-mail et le mot de passe que vous avez choisi.',
  'This invite has expired': 'Cette invitation a expiré',
  'Invite links work for seven days. Ask whoever invited you to send a new one.':
    'Les liens d’invitation sont valables sept jours. Demandez à la personne qui vous a invité de vous en envoyer un nouveau.',
  'This invite is no longer active': 'Cette invitation n’est plus active',
  'Ask whoever invited you to check your account and send a new invite.':
    'Demandez à la personne qui vous a invité de vérifier votre compte et de vous envoyer une nouvelle invitation.',
  'We could not load your invite': 'Impossible de charger votre invitation',
  'Check your connection and open the link from your email again.':
    'Vérifiez votre connexion et ouvrez à nouveau le lien reçu par e-mail.',
  'This invite link is not valid': 'Ce lien d’invitation n’est pas valide',
  'Open the link from your most recent invite email. An earlier link stops working when a new invite is sent.':
    'Ouvrez le lien de votre e-mail d’invitation le plus récent. Un lien antérieur cesse de fonctionner dès qu’une nouvelle invitation est envoyée.',
  'You are all set': 'Tout est prêt',
  'Download the OdinsEye app from the App Store or Google Play and sign in with {email} and the password you just chose. Your shifts for {company} will be waiting for you.':
    'Téléchargez l’application OdinsEye sur l’App Store ou Google Play et connectez-vous avec {email} et le mot de passe que vous venez de choisir. Vos vacations pour {company} vous y attendent.',
  'Your licence has been sent to {company} for review.':
    'Votre licence a été transmise à {company} pour examen.',
  'You can add your licence at any time from the app.':
    'Vous pouvez ajouter votre licence à tout moment depuis l’application.',
  'Your account is ready. Sign in with {email} and the password you just chose.':
    'Votre compte est prêt. Connectez-vous avec {email} et le mot de passe que vous venez de choisir.',
  'Add your licence': 'Ajoutez votre licence',
  '{company} checks your licence before putting you on licensed duties. Add it now, or skip this and add it later in the app.':
    '{company} vérifie votre licence avant de vous affecter à des services qui en exigent une. Ajoutez-la maintenant, ou passez cette étape et ajoutez-la plus tard dans l’application.',
  'Licence types could not be loaded. Skip this step and add your licence in the app.':
    'Impossible de charger les types de licence. Passez cette étape et ajoutez votre licence dans l’application.',
  'Name on licence': 'Nom figurant sur la licence',
  'Choose a licence type': 'Choisissez un type de licence',
  'Photo or scan of your licence': 'Photo ou scan de votre licence',
  'JPG, PNG, WebP or PDF, up to 10 MB.': 'JPG, PNG, WebP ou PDF, 10 Mo maximum.',
  'Submit licence': 'Soumettre la licence',
  'Submitting licence...': 'Envoi de la licence...',
  'Skip for now': 'Passer pour l’instant',
  'Upload your licence as a JPG, PNG, WebP or PDF file.':
    'Téléversez votre licence au format JPG, PNG, WebP ou PDF.',
  'That file is too large. Upload a file smaller than 10 MB.':
    'Ce fichier est trop volumineux. Téléversez un fichier de moins de 10 Mo.',
  'Enter the name printed on your licence': 'Saisissez le nom imprimé sur votre licence',
  'Choose your licence type': 'Choisissez votre type de licence',
  'Enter your licence number': 'Saisissez votre numéro de licence',
  'Enter an expiry date in the future': 'Saisissez une date d’expiration à venir',
  'The issue date cannot be in the future': 'La date de délivrance ne peut pas être dans le futur',
  'Upload a photo or scan of your licence': 'Téléversez une photo ou un scan de votre licence',
  'Your licence could not be submitted. You can add it later in the app.':
    'Votre licence n’a pas pu être soumise. Vous pourrez l’ajouter plus tard dans l’application.',

  // Email reset link
  'Confirm your new email': 'Confirmez votre nouvelle adresse e-mail',
  '{company} has asked to change the email you sign in to Odinseye with. Nothing changes unless you confirm.':
    '{company} a demandé à modifier l’adresse e-mail avec laquelle vous vous connectez à Odinseye. Rien ne change tant que vous ne confirmez pas.',
  'Current password': 'Mot de passe actuel',
  'The password you sign in with today. It stays the same.': 'Le mot de passe avec lequel vous vous connectez aujourd’hui. Il reste le même.',
  'You have not set up your account yet. Confirming takes you on to choose a password.':
    'Vous n’avez pas encore configuré votre compte. La confirmation vous permet ensuite de choisir un mot de passe.',
  'Confirm new email': 'Confirmer la nouvelle adresse e-mail',
  'Confirming...': 'Confirmation...',
  'Not expecting this? Close this page and your sign-in stays exactly as it is.':
    'Vous ne vous y attendiez pas ? Fermez cette page et votre connexion reste exactement la même.',
  'Enter your current password to confirm': 'Saisissez votre mot de passe actuel pour confirmer',
  'That password is not right. After five wrong tries this link stops working.':
    'Ce mot de passe est incorrect. Après cinq essais erronés, ce lien cesse de fonctionner.',
  'Your email could not be changed. Try again in a moment.': 'Votre adresse e-mail n’a pas pu être modifiée. Réessayez dans un instant.',
  'Your email has been changed': 'Votre adresse e-mail a été modifiée',
  'From now on, sign in to the Odinseye app and workspace with {email}. Your password has not changed.':
    'Désormais, connectez-vous à l’application et à l’espace de travail Odinseye avec {email}. Votre mot de passe n’a pas changé.',
  'This link has already been used': 'Ce lien a déjà été utilisé',
  'Your email has been changed. Sign in with your new email and the password you already have.':
    'Votre adresse e-mail a été modifiée. Connectez-vous avec votre nouvelle adresse et le mot de passe que vous avez déjà.',
  'This link has expired': 'Ce lien a expiré',
  'Email reset links work for seven days. Your sign-in has not changed. Ask your manager to send a new link.':
    'Les liens de réinitialisation de l’e-mail sont valables sept jours. Votre connexion n’a pas changé. Demandez à votre responsable d’en envoyer un nouveau.',
  'This link is no longer active': 'Ce lien n’est plus actif',
  'It was withdrawn or replaced by a newer one. Your sign-in has not changed.':
    'Il a été retiré ou remplacé par un lien plus récent. Votre connexion n’a pas changé.',
  'This link has been locked': 'Ce lien a été verrouillé',
  'It was tried with the wrong password too many times. Your sign-in has not changed. Ask your manager to send a new link.':
    'Un mot de passe incorrect a été saisi trop de fois. Votre connexion n’a pas changé. Demandez à votre responsable d’envoyer un nouveau lien.',
  'This account is not active': 'Ce compte n’est pas actif',
  'Its email cannot be changed. Ask your manager to check your account.':
    'Son adresse e-mail ne peut pas être modifiée. Demandez à votre responsable de vérifier votre compte.',
  'This email is now in use': 'Cette adresse e-mail est désormais utilisée',
  'Another account took this address after the link was sent. Your sign-in has not changed. Ask your manager to send a link to a different address.':
    'Un autre compte a pris cette adresse après l’envoi du lien. Votre connexion n’a pas changé. Demandez à votre responsable d’envoyer un lien vers une autre adresse.',
  'We could not load this link': 'Impossible de charger ce lien',
  'This link is not valid': 'Ce lien n’est pas valide',
  'Open the link from your email again. If it still does not work, ask your manager to send a new one.':
    'Rouvrez le lien depuis votre e-mail. S’il ne fonctionne toujours pas, demandez à votre responsable d’en envoyer un nouveau.',
};
